module.exports = __webpack_public_path__ + "img/logo_top.c007c217.png";